import React, {Component} from 'react'
import {createStructuredSelector} from "reselect"
import styled from "styled-components"
import {connect} from "react-redux"
import {
  DESKTOP_BREAKPOINT,
} from "manager/views/components/Settlement/constants"
import {
  resetInviteProviderError,
  sendProviderInvite,
  updateSettlementProviderSelectionInfo
} from "manager/redux/referral"
import {
  selectAgentOpId,
  selectAssignmentTransactionHash, selectInviteProviderError,
  selectSelectedSettlementProviderName, selectTransactionOpId
} from "manager/selectors/referral_selectors"
import FooterContainer from "manager/views/components/Settlement/Common/FooterContainer"
import {Grid, GridCell} from "manager/views/components/Settlement/Common/Grid"
import {SettlementInput} from "manager/views/components/Settlement/Common/Input"
import BackLink from "manager/views/components/Settlement/Common/BackLink"
import RedToast from "manager/views/components/Settlement/Common/RedToast"
import SettlementMaxWidth from "manager/views/components/Settlement/Common/SettlementMaxWidth"
import SettlementFormHr from "manager/views/components/Settlement/Common/SettlementFormHr"
import {SettlementForm, SettlementPadding} from "manager/views/components/Settlement/Common/SettlementCard"
import _ from "lodash"
import {segmentEventTracker} from "common/analytics"

const InviteProviderInputContainer = styled(SettlementForm)`
  display: flex;
  flex-direction: column;
  
  height: 100vh;
  margin-top: 0px;
  @media screen and ${DESKTOP_BREAKPOINT} {
    width: 936px;
    height: auto;
    margin-top: 24px;
  }
 `

const Header = styled(SettlementPadding)`
  padding-top: 24px;
  font-size: 26px;
  font-weight: bold;
  line-height: 33px;
  padding-bottom: 19.5px;
`

const BodyContainer = styled(SettlementPadding)`
  padding-bottom: 10px;
`

const BodyTitle = styled.div`
  margin-top: 14.5px;
  margin-bottom: 15px;
  font-size: 16px;
  font-weight: bold;
`

class InviteProviderInput extends Component {
  componentDidMount() {
    segmentEventTracker("Invite-Provider-Input Viewed", {'transaction_op_id': this.props.transaction_op_id, 'agent_op_id': this.props.agent_op_id})
  }

  componentWillUnmount(){
    this.props.resetInviteProviderError()
  }

  state = {
    canSave: false,
    companyName: this.props.selectedSettlementProviderName,
    repName: null,
    repEmail: null,
    repPhoneNumber: null,
  }

  hideInviteProviderInputView = () => {
    this.props.setInviteProviderInputView(false)
  }

  sendInvite = _.debounce(async () => {
    const {updateSettlementProviderSelectionInfo, sendProviderInvite, hash, selectedSettlementProviderName, transaction_op_id, agent_op_id} = this.props
    const {companyName, repName, repEmail, repPhoneNumber} = this.state
    const providerInfo = {
      company_name: companyName.trim(),
      contact_name: repName.trim(),
      contact_email: repEmail.trim(),
      contact_phone: repPhoneNumber ? repPhoneNumber.trim() : null
    }

    const isInviteSuccessful = await sendProviderInvite(hash, providerInfo)
    if (isInviteSuccessful) {
      if (selectedSettlementProviderName !== companyName.trim()) {
        await updateSettlementProviderSelectionInfo(hash, companyName.trim())
      }
      segmentEventTracker('Provider Invited', {'transaction_op_id': transaction_op_id, 'agent_op_id': agent_op_id})
      this.hideInviteProviderInputView()
    }
  })

  recalculateSaveMode = () => {
    const {companyName, repName, repEmail} = this.state
    if (companyName && companyName.trim() && repName && repName.trim() && repEmail && repEmail.trim()) {
      this.setState({canSave: true})
    } else {
      this.setState({canSave: false})
    }
  }

  handleOnChange = (field) => {
    return async (event) => {
      const value = event && event.target && event.target.value
      if (value !== undefined) {
        await this.setState({[field]: value})
        await this.recalculateSaveMode()
      }
    }
  }

  render() {
    const {canSave, companyName, repName, repEmail, repPhoneNumber} = this.state
    const {inviteProviderError} = this.props
    return (
      <SettlementMaxWidth>
        {inviteProviderError && <RedToast errorMessage="Failed to send invite. Please check your connection and try again."/>}
        <BackLink onClick={this.hideInviteProviderInputView}/>
        <InviteProviderInputContainer paddingRight='83px'>
          <Header>Invite Provider</Header>
          <SettlementFormHr/>
          <BodyContainer paddingRight='83px'>
            <BodyTitle>Provider Details</BodyTitle>
            <Grid>
              <GridCell>
                <SettlementInput label={"Provider Company Name*"}
                                 value={companyName}
                                 onChange={this.handleOnChange("companyName")}/>
              </GridCell>
              <GridCell>
                <SettlementInput label={"Contact Rep Name*"}
                                 value={repName}
                                 onChange={this.handleOnChange("repName")}/>
              </GridCell>
              <GridCell>
                <SettlementInput label={"Contact Rep Email*"}
                                 value={repEmail}
                                 onChange={this.handleOnChange("repEmail")}/>
              </GridCell>
              <GridCell>
                <SettlementInput label={"Contact Rep Phone Number"}
                                 value={repPhoneNumber}
                                 onChange={this.handleOnChange("repPhoneNumber")}/>
              </GridCell>
            </Grid>
          </BodyContainer>
          <SettlementFormHr/>
          <FooterContainer cancelOnClick={this.hideInviteProviderInputView}
                           buttonName="Send invite"
                           disabled={!canSave}
                           buttonOnClick={this.sendInvite}/>
        </InviteProviderInputContainer>

      </SettlementMaxWidth>
    )
  }
}


const selector = createStructuredSelector({
  hash: selectAssignmentTransactionHash,
  selectedSettlementProviderName: selectSelectedSettlementProviderName,
  inviteProviderError: selectInviteProviderError,
  transaction_op_id: selectTransactionOpId,
  agent_op_id: selectAgentOpId,
})

const actions = {
  sendProviderInvite,
  resetInviteProviderError,
  updateSettlementProviderSelectionInfo
}

export default connect(selector, actions)(InviteProviderInput)
